import * as apifetch from './fetch.js';

export async function createNewOrder(account_id, partner_code) {
    const urlEndpoint = '/order/createNewOrder.php';
    const accountId = Number(account_id);
    const validAccountId = Number.isSafeInteger(accountId) && accountId > 0 ? accountId : 0;

    if (validAccountId === 0) {
        throw new Error('Een geldige klant is verplicht om een bestelling aan te maken.');
    }

    if (partner_code && partner_code !== undefined) {
    } else {
        partner_code = 0;
    }

    const postData = {
        account_id: validAccountId,
        partner_code: partner_code,
        require_account: 1
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function handleOrderItem(order_line, action) {
    let urlEndpoint;

    //SbC DEPRICATED
    if (action === 'edit') {
        //urlEndpoint = '/order/handleOrderItem.php';
    }
    if (action === 'add') {
        //urlEndpoint = '/order/handleOrderItem.php';
    }
    //SbC only in use for DELETE
    if (action === 'delete') {
        urlEndpoint = '/order/deleteOrderItem.php';
    }

    const postData = order_line;

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function addOrderLine(order_line, id, action) {
    //console.log('SbC orderline add', order_line)
    const urlEndpoint = '/v2/orders/' + id + '/add';

    const postData = order_line;

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function editOrderLine(order_line, id, action) {
    //console.log('SbC orderline edit', order_line)
    const urlEndpoint = '/v2/orders/' + id + '/edit';

    const postData = order_line;

    //console.log('SbC edit', postData)

    // IIS rejects PUT on this route (405). The API maps this explicit POST
    // to the same order-line update handler.
    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function setOrderStatus(account_id, order_id, order_status) {
    const urlEndpoint = '/order/setOrderStatus.php';

    const postData = {
        account_id: account_id,
        order_id: order_id,
        order_status: order_status
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function getAccountOrders(account_id) {
    const urlEndpoint = '/accounts/getAccountOrders.php';

    const postData = {
        account_id: account_id
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData, { ttl: 10000 });
}

export async function saveOrderDataProfile(order_id, order_data) {
    const urlEndpoint = '/order/saveOrderProfile.php';

    const postData = {
        order_id: order_id,
        order_data: order_data
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function getOrderData(order_id) {
    const urlEndpoint = '/order/getOrderData.php';

    const postData = {
        order_id: order_id
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData, { ttl: 2000 });
}

export async function getOrderItemsData(order_id) {
    const urlEndpoint = '/order/getOrderItemsData.php';

    const postData = {
        order_id: order_id
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData, { ttl: 2000 });
}

export async function setOrderRemark(order_id, remark) {
    const urlEndpoint = '/order/setOrderRemark.php';
    const postData = {
        order_id: order_id,
        remark: remark
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function removeOrder(order_id) {
    const urlEndpoint = '/order/removeOrder.php';
    const postData = {
        order_id: order_id
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData);
}

export async function activatePCUse(pc) {
    const urlEndpoint = '/order/activatePCUse.php';
    const postData = {
        pc: pc
    }

    return apifetch.sbFetch(urlEndpoint, 'POST', postData);
}

export async function getOrderId(guid) {
    const urlEndpoint = '/order/getOrderId.php';

    const postData = {
        guid: guid
    }

    return apifetch.sbFetch(urlEndpoint, 'POST', postData, { ttl: 2000 });
}

export async function checkOrder(userId, cartId, orderId) {
    const endpoint = '/order/checkOrder.php';

    const payload = {
        order_id: orderId,
        account_id: userId,
        cart_id: cartId
    };

    return apifetch.authFetch(endpoint, 'POST', payload);
}

export async function checkDiscountsOverruled(order_id) {
    const urlEndpoint = '/order/checkDiscountsOverruled.php';

    const postData = {
        order_id: order_id
    }

    return apifetch.sbFetch(urlEndpoint, 'POST', postData, { ttl: 3000 });
}

export async function checkShippingCostsOverruled(order_id) {
    const urlEndpoint = '/order/checkShippingCostsOverruled.php';

    const postData = {
        order_id: order_id
    }

    return apifetch.sbFetch(urlEndpoint, 'POST', postData, { ttl: 3000 });
}

// SbC identical to checkShippingCostsOverruled but better naming
export async function checkNoShippingOrder(orderId) {
    const urlEndpoint = '/order/checkShippingCostsOverruled.php';

    const postData = {
        order_id: orderId
    }

    return apifetch.sbFetch(urlEndpoint, 'POST', postData, { ttl: 3000 });
}

export async function checkShippingCostsCustom(order_id) {
    const urlEndpoint = '/order/checkShippingCostsCustom.php';

    const postData = {
        order_id: order_id
    }

    return apifetch.sbFetch(urlEndpoint, 'POST', postData, { ttl: 3000 });
}

export async function getCustomShippingCosts(order_id) {
    const urlEndpoint = '/order/getCustomShippingCosts.php';

    const postData = {
        order_id: order_id
    }

    return apifetch.sbFetch(urlEndpoint, 'POST', postData, { ttl: 3000 });
}

export async function getOrderAvailability(order_id) {
    const validOrderId = Number(order_id);
    if (!Number.isSafeInteger(validOrderId) || validOrderId <= 0) {
        return { data: 'closed' };
    }

    const urlEndpoint = '/order/getOrderAvailability.php';

    const postData = {
        order_id: validOrderId
    }

    return apifetch.authFetch(urlEndpoint, 'POST', postData, { ttl: 2000 });
}
